<template>
  <div
    :class="[style.integrationCard, active ? style.integrationActive : '']"
    :data-testid="`integration-card-${integrationKey}`"
    @click="!isEdit ? $emit('action') : () => {}"
  >
    <header
      :class="[
        style.integrationHeader,
        !isEdit ? style.integrationListAdded : null
      ]"
      :style="{borderBottom: isLast ? 0 : ''}"
    >
      <div :class="style.logoIntegration">
        <img
          v-if="integrationData && integrationData.logo"
          :src="integrationData.logo"
          :class="style.icon"
          alt=""
        />
      </div>

      <div :class="style.nameAndCategory">
        <span :class="style.name">
          {{ getHeaderName(integrationKey, item) }}
        </span>

        <span :class="style.category">
          {{ integrationData?.category || "" }}
        </span>
      </div>

      <GhostButton :icon="addIcon" @click="$emit('action')" v-if="isEdit" />
    </header>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./IntegrationComponent.module.scss";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";
import {integrationItem} from "@/page/setting/integration/IntegrationTypes";
import addIcon from "$images/icons/button/Name=Add, Size=16, Tone=Default.svg";

type IntegrationCardData = {
  logo?: string;
  category?: string;
};

const integrationLabels: Record<string, string> = {
  amoCrm: "AmoCRM",
  bitrixCrm: "Bitrix24",
  cbkiller: "CallbackKILLER",
  dentalPro: "DentalPRO",
  domain: "Домен",
  email: "Email",
  externalLink: "Виджет",
  google: "Google Sheets",
  ident: "IDENT",
  macDent: "MacDent",
  max: "MAX",
  metric: "Яндекс Метрика",
  telegram: "Telegram",
  webSite: "Веб-сайт"
};

export default defineComponent({
  name: "IntegrationCard",
  components: {GhostButton},
  props: {
    integrationKey: {type: String, required: true},
    integrationData: {
      type: Object as PropType<IntegrationCardData>,
      required: false,
      default: () => ({})
    },
    item: {
      type: [Object, String] as PropType<integrationItem | string>,
      required: false
    },
    active: {type: Boolean, default: false},
    icon: {type: String, required: true},
    isLast: {type: Boolean, default: false},
    isEdit: {type: Boolean, default: false}
  },
  emits: ["action"],
  methods: {
    getIntegrationLabel(key: string): string {
      return integrationLabels[key] || key;
    },
    getHeaderName(key: string, data?: integrationItem | string): string {
      const label = this.getIntegrationLabel(key);

      if (!data) return label;

      if (typeof data === "string") return data;

      const newData = data as {name?: string; clinic?: {name: string}};

      if (newData?.name) return `${label}: ${newData.name}`;

      if (newData?.clinic?.name) return `${label}: ${newData?.clinic?.name}`;

      if (key === "amoCrm") {
        const amoData = data as {client?: {name?: string}};

        if (amoData.client?.name) return `${label}: ${amoData.client.name}`;
      }

      return label;
    }
  },
  data() {
    return {
      style,
      addIcon
    };
  }
});
</script>
